// extracted by mini-css-extract-plugin
export default {"container":"TableauComposante_container__waXSx"};